import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import HtmlParser from 'html-react-parser';
import { Textfit } from 'react-textfit';

import { fontDefault, fontkoKR, CloseButton, IconVolumeOn } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { FormattedKoPhrase, FormattedKoEnPhrase } from '@mirinae/lessons/components/lesson/elements/Phrase';
import { HelpBubble, registerHelp } from '@mirinae/lessons/components/lesson/Help';
import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import IconZoom from '@mirinae/lessons/components/lesson/icons/icon-zoom.svg';
import { playTTS } from '@mirinae/lessons/modules/libs/lessonLib';
import { zIndex } from '@mirinae/lessons/modules/defines/styles';

const ExampleKoStyle = { align: 'left', koFontWeight: 400, koreanFontSize: '14px', list: true };
const ExamplePopupKoEnStyle = { align: 'left', koFontWeight: 'bold', koreanFontSize: '24px', englishFontSize: '14px', enFontWeight: 500 };

const VariantTableElement = styled(Element)`
    position: relative;
    font-family: ${fontDefault};
    ${!os.isOthers && `
        margin-bottom: 24px;
    `}
`;

const VariantGrid = styled.div`
    border: 1px solid #DFDFDF;
    border-radius: 10px;
    overflow: hidden;
    text-align: center;
`;

const Header = styled.div`
    display: grid;
    grid-template-columns: 135px 572px;
    height: 40px;
`;

const Conditions = styled.div`
    display: grid;
    grid-template-columns: 135px 572px;
    height: 60px;
`;

const Meanings = styled(Conditions)`
`;

const Variants = styled.div`
    display: grid;
    grid-template-columns: 135px 572px;
    height: 60px;
`;

const Examples = styled.div`
    display: grid;
    grid-template-columns: 135px 572px;
    margin-bottom: -1px;
    height: 180px;
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7A7A7A;
    font-weight: 700;
    font-size: 12px;
    background-color: #EFF4F7;
    border-bottom: 1px solid #fff;
`;

const CellWrapper = styled.div`
    display: flex;
    justify-content: space-around;
`;

const Cell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 25px;
    font-weight: 400;
    font-size: 14px;
    border-bottom: 1px solid #DFDFDF;
    border-left: 1px solid #DFDFDF;
`;

const VariantCell = styled(Cell)`
    display: flex;
    flex-direction: ${os.isOthers ? 'column' : 'row'};
    font-family: ${fontkoKR};
    font-weight: 700;
    color: #F6C844;
    ${os.isOthers ? `
        font-size: 24px;
    ` : `
        justify-content: flex-start;
        padding: 0 14px;
        background-color: #fff;
        border: 0;
        font-size: 16px;
    `}
`;

const VariantAnnotation = styled.div`
    font-weight: 700;
    font-size: 15px;
     ${os.isOthers ? 'margin-top: -5px' : 'margin-left: 5px'};
`;

const ExampleWrapper = styled(Cell)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow-y: auto;
    justify-content: start;
  
    ${os.isOthers ? `
        height: 182px;
        padding: 6px 9px;
    ` : `
        padding: 6px 14px;
        border: 0;
    `}
`;

// const Example = styled(ListedKoPhrase)` //  FormattedKoPhrase)\` for now, to show English phrase while style being coded
// `;

const ZoomButton = styled(LessonButton)`
    position: absolute;
    right: 10px;
    bottom: 12px;
    width: 25px;
    height: 25px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
`;

const VariantGridMobile = styled.div`
    width: 100%;  
`;

const HeaderMobile = styled.div`
    margin-bottom: 10px;
    padding: 13px 20px;
    border-radius: 10px;
    background-color: #F4F4F4;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    strong {
        display: block;
        margin-bottom: 3px;
        color: #7A7A7A;
        font-size: 12px;
    }
`;
const TableMobile = styled.div`
    border: 1px solid #DFDFDF;
    border-radius: 10px;
    overflow: hidden;
    & + & {
        margin-top: 10px;
    }
`;
const CellWrapperMobile = styled.div`
    display: flex;
    border-bottom: 1px solid #DFDFDF;
    background-color: #EFF4F7;
`;
const CellHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 94px;
    height: 40px;
    color: #7A7A7A;
    font-size: 12px;
    font-weight: 700; 
`;
const CellMobile = styled.div`
    width: 100%;
    padding: 6px 14px;
    font-size: 14px;
    background-color: #fff;
    // line-height: 40px;  !!??
`;
const VariantPopup = styled.div`
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    ${os.isOthers ? `
        position: absolute;
        border: 1px solid #DFDFDF;
        border-radius: 10px;
        overflow: hidden;
    ` : `
        position: fixed;
        z-index: ${zIndex.float};
        padding: 48px 20px;
    `}
`;
const PopupHead = styled.div`
    dl {
        display: flex;
        width: calc(100% - 39px);
    }
    dt {
        flex-shrink: 0;
        padding: 0 14px;
        white-space: nowrap;
        background-color: #EFF4F7;
        color: #7A7A7A;
        font-size: 12px;
        font-weight: 700;
        line-height: 40px;
    }
    dd {
        padding: 0 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;

        &.variant {
            font-family: ${fontkoKR};
            font-weight: 700;
            font-size: 16px;
            color: #F6C844;
        }
    }

    ${os.isOthers ? `
        display: flex;
        height: 40px;
        border-bottom: 1px solid #DFDFDF;

        dd {
            width: 100%;
            &:nth-child(2) {
                width: 50%;
            }
        }
        button {
            flex-shrink: 0;
            width: 39px;
            height: 39px;
            border-left: 1px solid #DFDFDF;
        }
    ` : `
        dl {
            flex-wrap: wrap;
        }
        dt {
            width: 94px;
            border-radius: 10px;
            text-align: center;
            :nth-child(3) {
                margin-top: 9px;
            }
        }
        dd {
            width: calc(100% - 94px);
            &:nth-child(4) {
                margin-top: 9px;
            }
        }
        button {
            position: absolute;
            top: 0;
            right: 0;
            width: 55px;
            height: 55px;
            svg {
                width: 15px;
                height: 15px;
            }
        }
    `}
`;
const PopupBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    & > div {
        width: 100%;
        max-height: 100%;
        height: calc(100vh - 200px);
        padding: 23px 49px;
        overflow-y: auto;
    }
    ${os.isOthers ? `
        height: 289px;
    ` : `
        min-height: 493px;
        margin-top: 28px;
        & > div {
            padding: 20px 30px;
        }
    `}
`;
const PopupExample = styled.div`
    display: flex;
    & + & {
        margin-top: 30px;
    }
`;
const SpeakerButton = styled(LessonButton)`
    width: 25px;
    height: 25px;
    margin-top: 5px;
    margin-right: 15px;
`;

const VariantsTable = ({ element }) => {
    const [audioEl, setAudioEl] = useState(null);

    const initPopupState = {
        display: false,
        condition: '',
        variant: '',
        examples: [],
    };
    const [popupData, setPopupData] = useState(initPopupState);

    useEffect(() => {
        if (!os.isOthers) {
            if (popupData.display) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    }, [popupData.display]);

    const koreanEmphasisConverter = (sentence) => {
        const re = /[\u3131-\uD79D]/ugi;
        const s = sentence.split(' ');
        const result = s.map((d) => (d.match(re) ? `<strong>${d}</strong>` : d));
        return HtmlParser(result.join(' '));
    };
    const handleDisplayPopup = (variant) => {
        setPopupData(prev => ({ ...prev,
            display: true,
            condition: variant.fieldsByName.condition.value,
            variant: variant.fieldsByName.variant.value || variantEntrys.find(v => v.fieldsByName.variant.value).fieldsByName.variant.value,
            examples: variant.fields.filter(f => f.type === 'parts'),
        }));
    };
    const handleClosePopup = () => {
        setPopupData(initPopupState);
    };
    const handleTTS = (object) => {
        const sentence = object.parts.koreanParts.reduce((prev, curr) => (`${prev.value || prev}${curr.value}`));
        playTTS(audioEl, sentence, null, { speed: '80%' });
    };

    // gather variantEntrys in my parent so we can control their layout (marked as managedByPage in lessonDefs, so default layout engine ignores them)
    const variantEntrys = element.parent.children.filter(e => e.componentName === 'variantEntry'); // just element ordering .sort((c1, c2) => c1.geom.y - c2.geom.y);

    const ExampleCell = ({ variant }) => (
        <ExampleWrapper>
            { variant.fields.filter(f => f.type === 'parts').map(f => !f.hidden && (
                <FormattedKoPhrase key={f.index} phrase={f} phraseStyle={ExampleKoStyle} />
            ))}
            <ZoomButton type="button" onClick={() => handleDisplayPopup(variant)}>
                <img src={IconZoom} alt="Zoom" />
            </ZoomButton>
        </ExampleWrapper>
    );

    return (
        <VariantTableElement element={element} className="variant-table">
            {os.isOthers ? (
                <VariantGrid element={element}>
                    <Header>
                        <Label>{element.fieldsByName.headerLabel.value.replace(':', '')}</Label>
                        <Cell>{element.fieldsByName.headerText.value}</Cell>
                    </Header>
                    { !element.fieldsByName.conditionRow.hidden && (
                        <Conditions>
                            <Label>{element.fieldsByName.conditionRow.parts.englishParts[0].value}</Label>
                            <CellWrapper>
                                { variantEntrys.map(v => (
                                    <Cell key={v.index} style={{ maxHeight: 70 }}>
                                        <Textfit max={14} style={{ padding: '4px 0', maxHeight: 70 }} mode="multi">{koreanEmphasisConverter(v.fieldsByName.condition.value)}</Textfit>
                                    </Cell>
                                ))}
                            </CellWrapper>
                        </Conditions>
                    )}
                    { !element.fieldsByName.variantRow.hidden && (
                        <Variants>
                            <Label>{element.fieldsByName.variantRow.parts.englishParts[0].value}</Label>
                            <CellWrapper>
                                { variantEntrys.map(v => v.fieldsByName.variant.value && (
                                    <VariantCell key={v.index}>
                                        {v.fieldsByName.variant.value}
                                        {v.fieldsByName.annotation.value && <VariantAnnotation>{v.fieldsByName.annotation.value}</VariantAnnotation>}
                                    </VariantCell>
                                ))}
                            </CellWrapper>
                        </Variants>
                    )}
                    { !element.fieldsByName.meaningRow.hidden && (
                        <Meanings>
                            <Label>{element.fieldsByName.meaningRow.parts.englishParts[0].value}</Label>
                            <CellWrapper>
                                { variantEntrys.map(v => (
                                    <Cell key={v.index}><div>{koreanEmphasisConverter(v.fieldsByName.condition.value)}</div></Cell>
                                ))}
                            </CellWrapper>
                        </Meanings>
                    )}
                    { !element.fieldsByName.examplesRow.hidden && (
                        <Examples>
                            <Label>{element.fieldsByName.examplesRow.parts.englishParts[0].value}</Label>
                            <CellWrapper>
                                { variantEntrys.map(v => (
                                    <ExampleCell key={v.index} variant={v} />
                                ))}
                            </CellWrapper>
                        </Examples>
                    )}
                </VariantGrid>
            ) : (
                <VariantGridMobile element={element}>
                    <HeaderMobile>
                        <strong>{element.fieldsByName.headerLabel.value}</strong>
                        {element.fieldsByName.headerText.value}
                    </HeaderMobile>
                    { variantEntrys.map(v => (
                        <TableMobile key={v.index}>
                            { !element.fieldsByName.conditionRow.hidden && (
                                <CellWrapperMobile>
                                    <CellHead>{element.fieldsByName.conditionRow.parts.englishParts[0].value}</CellHead>
                                    <CellMobile>{koreanEmphasisConverter(v.fieldsByName.condition.value)}</CellMobile>
                                </CellWrapperMobile>
                            )}
                            { !element.fieldsByName.variantRow.hidden && v.fieldsByName.variant.value && (
                                <CellWrapperMobile>
                                    <CellHead>{element.fieldsByName.variantRow.parts.englishParts[0].value}</CellHead>
                                    <VariantCell>
                                        {v.fieldsByName.variant.value}
                                        {v.fieldsByName.annotation.value && <VariantAnnotation>{v.fieldsByName.annotation.value}</VariantAnnotation>}
                                    </VariantCell>
                                </CellWrapperMobile>
                            )}
                            { !element.fieldsByName.meaningRow.hidden && (
                                <CellWrapperMobile>
                                    <CellHead>{element.fieldsByName.meaningRow.parts.englishParts[0].value}</CellHead>
                                    <CellMobile>{koreanEmphasisConverter(v.fieldsByName.condition.value)}</CellMobile>
                                </CellWrapperMobile>
                            )}
                            { !element.fieldsByName.examplesRow.hidden && (
                                <ExampleCell key={v.index} variant={v} />
                            )}
                        </TableMobile>
                    ))}
                </VariantGridMobile>
            )}
            { popupData.display && (
                <VariantPopup>
                    <PopupHead>
                        <dl>
                            { popupData.variant && !element.fieldsByName.variantRow.hidden && (
                                <>
                                    <dt>{element.fieldsByName.variantRow.parts.englishParts[0].value}</dt>
                                    <dd className="variant">{popupData.variant}</dd>
                                </>
                            )}
                            { popupData.condition && !element.fieldsByName.conditionRow.hidden && (
                                <>
                                    <dt>{element.fieldsByName.conditionRow.parts.englishParts[0].value}</dt>
                                    <dd className="condition">{koreanEmphasisConverter(popupData.condition)}</dd>
                                </>
                            )}
                            { popupData.condition && !element.fieldsByName.meaningRow.hidden && (
                                <>
                                    <dt>{element.fieldsByName.meaningRow.parts.englishParts[0].value}</dt>
                                    <dd className="condition">{koreanEmphasisConverter(popupData.condition)}</dd>
                                </>
                            )}
                        </dl>
                        <CloseButton onClick={handleClosePopup} />
                    </PopupHead>
                    <PopupBody>
                        <div>
                            { popupData.examples.map((f, i) => !f.hidden && (
                                <PopupExample key={i}>
                                    <SpeakerButton type="button" onClick={() => handleTTS(f)}>
                                        <IconVolumeOn width="25" height="25" />
                                    </SpeakerButton>
                                    <FormattedKoEnPhrase key={f.index} phrase={f} phraseStyle={ExamplePopupKoEnStyle} />
                                </PopupExample>
                            ))}
                        </div>
                    </PopupBody>
                    <audio ref={setAudioEl} />
                </VariantPopup>
            )}
        </VariantTableElement>
    );
};

registerHelp(VariantsTable, [
    <HelpBubble
        title="Pattern variant table"
        desktop={{ anchor: '.variant-table', titleAt: 'bottom', arrowPos: 'left', arrowDir: 'down', style: { bottom: 265, left: 'calc(50% - 10px)', contentWidth: 280 } }}
        mobile={{ anchor: '.variant-table', titleAt: 'top', arrowPos: 'left', arrowDir: 'down', style: { top: -35, left: 40, contentWidth: 205 } }}>
        <p>This table summarizes all the variations of the lesson&apos;s pattern.</p>
        <p>You can click on a <strong>start button</strong> to take an optional mini-lesson on the variant. Progress in the mini-lesson will be shown in the blue progress bars
            here and on the mini-lesson pages.
        </p>
    </HelpBubble>,
]);

export default VariantsTable;
